import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { EnvService } from './app/_servicos/env.service';
import { AppModule } from './app/app.module';

let env: EnvService = new EnvService();

if (
  env.ambiente.toUpperCase() == 'PROD' ||
  env.ambiente.toUpperCase() == 'PRODUCAO'
) {
  console.log('PROD -> TRUE');
  enableProdMode();
} else {
  console.log('PROD -> FALSE');
}

//console.log('env2');

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
